// Returns undefined for filter field
function NoFilter() {
}

export default NoFilter;